import axios from "axios";

const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || "").replace(
  /\/$/,
  ""
);

/**
 * Charge le stock d'un tenant.
 * @param {string} token - JWT Auth0
 * @param {string|number} tenantId - tenant_id du JWT (ou override)
 */
export async function fetchStockByTenant(token, tenantId) {
  if (!API_BASE_URL) {
    throw new Error("VITE_API_BASE_URL n'est pas configuré.");
  }
  if (!tenantId) {
    throw new Error("Identifiant tenant manquant.");
  }

  const { data } = await axios.get(
    `${API_BASE_URL}/api/stock/${tenantId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return data;
}

/**
 * Filtre les lignes de stock par SKU, Gencod ou SKU client.
 */
export function filterStockLines(stockLineList = [], query = "") {
  const trimmed = query.trim();
  if (!trimmed) return [];

  const upper = trimmed.toUpperCase();

  return stockLineList.filter(
    (product) =>
      product.ProductSku?.toUpperCase().includes(upper) ||
      product.Gencod?.includes(trimmed) ||
      product.ProductClientSku?.toUpperCase().includes(upper)
  );
}

/**
 * Applique les filtres UI (statut stock + produits abandonnés).
 * @param {object[]} matchedLines - résultats déjà filtrés par texte
 * @param {{ stockStatuses?: number[], showAbandoned?: boolean, isAbandoned?: Function }} options
 */
export function applyResultFilters(
  matchedLines = [],
  {
    stockStatuses = [],
    showAbandoned = false,
    isAbandoned = (product) => product?.SaleStatus === 3,
  } = {}
) {
  const abandonedCount = matchedLines.filter((product) =>
    isAbandoned(product)
  ).length;

  let results = matchedLines;

  if (!showAbandoned) {
    results = results.filter((product) => !isAbandoned(product));
  }

  if (stockStatuses.length > 0) {
    results = results.filter((product) =>
      stockStatuses.includes(product.StockStatus)
    );
  }

  return { results, abandonedCount };
}

const PRODUCT_MEDIA_BASE =
  "https://media.pro-living.fr/resized/100x100/catalog/product";

/**
 * Construit l'URL image catalogue à partir du ProductSku.
 * Ex. TESS-CHA03_B02 → …/t/e/tess-cha03_b02__ps_02.jpg
 */
export function buildProductImageUrl(productSku) {
  if (!productSku || typeof productSku !== "string") return "";

  const sku = productSku.trim().toLowerCase();
  if (sku.length < 2) return "";

  return `${PRODUCT_MEDIA_BASE}/${sku[0]}/${sku[1]}/${sku}__ps_02.jpg`;
}

/**
 * Formate l'horodatage API (YYYYMMDDHHmmss) en libellé FR.
 */
export function formatStockTimestamp(horodatage) {
  if (!horodatage) return "";
  const str = horodatage.toString();
  if (str.length < 14) return str;

  return (
    `${str.substring(6, 8)}/${str.substring(4, 6)}/${str.substring(0, 4)}` +
    ` à ${str.substring(8, 10)}:${str.substring(10, 12)}:${str.substring(12, 14)}`
  );
}
